export const zh_CN = {
  // amplifier.detail
  '返回': '返回',
  '功放控制': '功放控制',
  '功放控制（已缩放适配一屏）': '功放控制（已缩放适配一屏）',

  // amplifier.header
  '连接状态': '连接状态',
  'MCU连接状态': 'MCU连接状态',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: 未连接',
  'Connected': '已连接',
  'Disconnected': '未连接',
  '输出天线：': '输出天线：',
  '手动选择': '手动选择',
  '自动选择': '自动选择',
  '触发模式：': '触发模式：',
  '接收状态': '接收状态',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': '输入功率触发',
  '时间': '时间',
  '系统同步': '系统同步',
  '报警信息': '报警信息',
  '设备报警': '设备报警',
  '点击查看详情': '点击查看详情',
  '清除报警': '清除报警',
  '清除报警指令已发送': '清除报警指令已发送',
  '清除报警发送失败': '清除报警发送失败',
  '密码验证': '密码验证',
  '请输入密码': '请输入密码',
  '提示：密码为 666': '提示：密码为 666',
  '密码验证成功': '密码验证成功',
  '密码错误，请重试': '密码错误，请重试',
  '工程参数设置已保存': '工程参数设置已保存',
  '工程参数设置': '工程参数设置',
  '审计日志': '审计日志',
  '报警日志': '报警日志',
  'MCU日志': 'MCU日志',
  '更新审计日志指令已发送': '更新审计日志指令已发送',
  '更新报警日志指令已发送': '更新报警日志指令已发送',
  '更新MCU日志指令已发送': '更新MCU日志指令已发送',
  '更新审计日志发送失败': '更新审计日志发送失败',
  '更新报警日志发送失败': '更新报警日志发送失败',
  '更新MCU日志发送失败': '更新MCU日志发送失败',
  '启用报警信息': '启用报警信息',
  '按日志类型与精确时间范围查询设备事件': '按日志类型与精确时间范围查询设备事件',
  '共 {count} 条': '共 {count} 条',
  '开始时间': '开始时间',
  '结束时间': '结束时间',
  '选择开始时间': '选择开始时间',
  '选择结束时间': '选择结束时间',
  '数量': '数量',
  '等级': '等级',
  '消息': '消息',
  '更新': '更新',
  '确认': '确认',
  '取消': '取消',
  '确定': '确定',
  '已连接': '已连接',
  '未连接': '未连接',

  // amplifier.bottom
  '输入天线1': '输入天线1',
  '输入天线2': '输入天线2',
  '输入天线衰减器': '输入天线衰减器',
  '输入衰减器': '输入衰减器',
  '功放': '功放',
  '天调': '天调',
  '关闭': '关闭',
  '开启': '开启',
  '调谐中': '调谐中',
  '调谐失败': '调谐失败',
  '输出天线1': '输出天线1',
  '输出天线2': '输出天线2',
  '输出天线3': '输出天线3',
  '输出天线4': '输出天线4',
  '假负载': '假负载',
  '频率范围无效': '频率范围无效',
  '天线配置保存失败': '天线配置保存失败',

  // amplifier.middle
  '频段未获取': '频段未获取',
  'Counter': '计数器',
  'Hamlib': 'Hamlib',
  '滤波器：': '滤波器：',
  '频段：': '频段：',
  '输入': '输入',
  '输出': '输出',
  '反向功率': '反向功率',
  '驻波': '驻波',
  '电压:': '电压:',
  '电流:': '电流:',
  '功率:': '功率:',
  '温度:': '温度:',
  '选择频段': '选择频段',
  '编辑频段': '编辑频段',
  '波段电压': '波段电压',
  '频段名称': '频段名称',
  '频段值': '频段值',
  '当前波段电压：': '当前波段电压：',
  '波段电压:': '波段电压:',
  '自动模式': '自动模式',
  '协议模式': '协议模式',

  // amplifier.popup
  '功放开启确认': '功放开启确认',
  '设备请求确认开启功放。': '设备请求确认开启功放。',
  '更新确认': '更新确认',
  '确认更新': '确认更新',
  '设备检测到可用更新，是否开始下载并安装？': '设备检测到可用更新，是否开始下载并安装？',
  '更新进度': '更新进度',
  '正在更新…': '正在更新…',
  '重启确认': '重启确认',
  '立即重启': '立即重启',
  '稍后重启': '稍后重启',
  '更新已安装完成，是否立即重启？': '更新已安装完成，是否立即重启？',
  '处理中…': '处理中…',

  // amplifier.alarm
  '输入正向功率保护': '输入正向功率保护',
  '输入反向功率保护': '输入反向功率保护',
  '功放管输入过电压保护': '功放管输入过电压保护',
  '功放管输出过电压保护': '功放管输出过电压保护',
  '功放输出正向功率保护': '功放输出正向功率保护',
  '功放管输出反向功率保护': '功放管输出反向功率保护',
  '过流保护': '过流保护',
  '过压保护': '过压保护',
  '过温保护': '过温保护',
  '高驻波': '高驻波',
  '频率误差过大': '频率误差过大',
  '功放管输入过功率保护': '功放管输入过功率保护',
  '功放管输出过功率保护': '功放管输出过功率保护',
  '输出正向功率保护': '输出正向功率保护',
  '输出反向功率保护': '输出反向功率保护',
  '输入高驻波': '输入高驻波',
  '输出高驻波': '输出高驻波',

  // amplifier.antenna
  '修改天线配置': '修改天线配置',
  '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。': '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。',
  '自定义名称': '自定义名称',
  '开始频率 (Hz)': '开始频率 (Hz)',
  '结束频率 (Hz)': '结束频率 (Hz)',
  '保存': '保存',
  '保存中…': '保存中…',
  '请输入有效的频率（Hz）': '请输入有效的频率（Hz）',
  '起始频率不能低于 {min} Hz': '起始频率不能低于 {min} Hz',
  '结束频率不能低于 {min} Hz': '结束频率不能低于 {min} Hz',
  '起始频率不能大于结束频率': '起始频率不能大于结束频率',

  // amplifier.systemSync
  '电台设置': '电台设置',
  '硬件菜单': '硬件菜单',
  '服务器设置': '服务器设置',
  '端口:': '端口:',
  '波特率:': '波特率:',
  '电台:': '电台:',
  '电台选择': '电台选择',
  '硬件版本:': '硬件版本:',
  '软件版本:': '软件版本:',
  '检查更新': '检查更新',
  '串口:': '串口:',
  '连接:': '连接:',
  '重新连接': '重新连接',
  '重启软件': '重启软件',
  '配置': '配置',
  'MQTT 配置': 'MQTT 配置',
  '串口选择': '串口选择',
  '波特率选择': '波特率选择',
  '共 {count} 个可用串口，点击切换 Hamlib 串口': '共 {count} 个可用串口，点击切换 Hamlib 串口',
  '共 {count} 个可选波特率，点击切换 Hamlib 波特率': '共 {count} 个可选波特率，点击切换 Hamlib 波特率',
  '共 {count} 个 Hamlib 机型': '共 {count} 个 Hamlib 机型',
  '请选择电台': '请选择电台',
  '设备 ID 无效，无法重启软件': '设备 ID 无效，无法重启软件',
  '重启软件指令已发送': '重启软件指令已发送',
  '重启软件指令发送失败': '重启软件指令发送失败',
  '可更新': '可更新',

  // amplifier.engineering
  '校准系数': '校准系数',
  '其他': '其他',
  '备份': '备份',
  '立即备份': '立即备份',
  '还原选中': '还原选中',
  '清除全部': '清除全部',
  '暂无备份': '暂无备份',
  '删除备份': '删除',
  '确认还原选中备份？': '确认还原选中备份？',
  '确认清除全部备份？': '确认清除全部备份？',
  '确认删除该备份？': '确认删除该备份？',
  '备份指令发送失败': '备份指令发送失败',
  '备份操作失败': '备份操作失败',
  '备份已创建': '备份已创建',
  '还原成功': '还原成功',
  '删除备份成功': '删除成功',
  '清除备份成功': '已清除全部备份',
  '备份不可用': '备份不可用',
  '该备份校验失败，无法还原': '该备份校验失败，无法还原',
  '正在处理备份': '正在处理…',
  '频段': '频段',
  '电压校准系数': '电压校准系数',
  '电流校准系数': '电流校准系数',
  '频率校准系数': '频率校准系数',
  'VGS校准系数': 'VGS校准系数',
  'DAC参考电压': 'DAC参考电压',
  '偏置电压': '偏置电压',
  '截止频率': '截止频率',
  '输入正向功率校准系数': '输入正向功率校准系数',
  '输入反向功率校准系数': '输入反向功率校准系数',
  '输出正向功率校准系数': '输出正向功率校准系数',
  '输出反向功率校准系数': '输出反向功率校准系数',
  '功放输入功率校准': '功放输入功率校准',
  '功放输出功率校准': '功放输出功率校准',
  '保护电压': '保护电压',
  '保护电流': '保护电流',
  '保护输入正向功率': '保护输入正向功率',
  '保护输入反向功率': '保护输入反向功率',
  '保护输出正向功率': '保护输出正向功率',
  '保护输出反向功率': '保护输出反向功率',
  '输入保护驻波比': '输入保护驻波比',
  '输出保护驻波比': '输出保护驻波比',
  '保护频率误差': '保护频率误差',
  '保护温度': '保护温度',
  '驻波调谐值': '驻波调谐值',
  'PTT触发电功率': 'PTT触发电功率',
  '恢复出厂设置': '恢复出厂设置',
  '功能待对接': '功能待对接',
  '天线切换失败': '天线切换失败',
  'Command send/receive log': 'Command send/receive log',
  '输入 <100W': '输入 <100W',
  '减少 {label}': '减少 {label}',
  '增加 {label}': '增加 {label}',
  '工程参数分页': '工程参数分页',
  '数据同步': '数据同步',
  '数据同步指令已发送': '数据同步指令已发送',
  '数据同步发送失败': '数据同步发送失败',
  '屏蔽': '屏蔽',

  // amplifier.calibration (legacy modal)
  '校准参数': '校准参数',
  '电压参数': '电压参数',
  '保存参数': '保存参数',

  // amplifier.protocolModal
  '串口': '串口',
  '波特率': '波特率',
  '请选择串口': '请选择串口',
  '请选择波特率': '请选择波特率',
  '请选择rig': '请选择rig',

  // amplifier.calibrationModal
  '频段校准系数': '频段校准系数',
  'vgs:': 'vgs:',
  'vgs频率:': 'vgs频率:',
  '电压': '电压',
  '输出正向功率比较电压': '输出正向功率比较电压',
  '输出反向功率比较电压': '输出反向功率比较电压',
  '输入反向功率比较电压': '输入反向功率比较电压',
  '输入正向功率比较电压': '输入正向功率比较电压',
  '过流比较电压': '过流比较电压',
  '功率触发PTT电压': '功率触发PTT电压',
  '功放管输入功率比较电压': '功放管输入功率比较电压',
  '功放管输出功率比较电压': '功放管输出功率比较电压',
  '负载电阻': '负载电阻',
  '频率测量值': '频率测量值',
  '天调电容选择值': '天调电容选择值',
  '天调电感选择值': '天调电感选择值',
  '保护驻波比': '保护驻波比',
  '工程参数设置界面': '工程参数设置界面',
} as const;

export type AmplifierLocaleKey = keyof typeof zh_CN;
export type AmplifierLocale = Record<AmplifierLocaleKey, string>;
